import React, {Component} from 'react';
import LineItem from './LineItem';
class Cart extends Component {
  constructor(props) {
    super(props);
    this.openCheckout = this.openCheckout.bind(this);
  }
  openCheckout() {
    window.open(this.props.checkout.webUrl);
  }
  render() {
    let line_items = this.props.checkout.lineItems.map(line_item => {
      return <LineItem updateQuantityInCart={this.props.updateQuantityInCart} removeLineItemInCart={this.props.removeLineItemInCart} key={line_item.id.toString()} line_item={line_item} />;
    });
    return (
      <div className={`Cart ${this.props.isCartOpen ? 'Cart--open' : ''}`}>
        
        <header className="Cart__header">
          <h3>Bag</h3>
          <button onClick={this.props.toggleCart} className="Cart__close">
            ×
          </button>
        </header>
        <ul className="Cart__line-items">{line_items}</ul>
        <div className="Cart-info clearfix">
        </div>
        <footer className="Cart__footer">
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Subtotal</div>
            <div className="Cart-info__pricing">
              <span className="pricing">$ {this.props.checkout.subtotalPrice}</span>
            </div>
          </div>
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Taxes are calculated at checkout.</div>
          </div>
          <button className="Cart__checkout button" onClick={this.openCheckout}>
            Checkout
          </button>
        </footer>
      </div>
    );
  }
}
export default Cart;